import React from 'react';

const UnknownError = ({ onRetry }: any) => {
  const handleRetry = () => {
    if (onRetry) {
      onRetry();
    } else {
      window.location.reload();
    }
  };

  return (
    <div className="flex items-center justify-center pt-10 bg-gray-100 px-4">
      <div className="bg-white shadow-md rounded-xl p-8 max-w-md w-full text-center">
        <div className="text-6xl mb-4 text-orange-500">🚨</div>
        <h1 className="text-2xl font-semibold mb-2">Unknown Error Occurred</h1>
        <p className="text-gray-600 mb-6">
          Something went wrong and we’re not sure what it was.<br />
          Please try again or contact support.
        </p>
        <button
          onClick={handleRetry}
          className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition"
        >
          Retry
        </button>
      </div>
    </div>
  );
};

export {UnknownError};